module.exports = __webpack_public_path__ + "static/media/taiwan_01.d689a0d1.png";